export const vplatformInfo = {
  wetv: '8',
  iflix: '8',
};

export const videoAppidInfo = {
  wetv: '1200012',
  iflix: '1200016',
};

export const PTInfo = {
  wetv: 'WETVLINUX',
  iflix: 'IFLIXLINUX',
};

export const TVKPlatformInfo = {
  wetv: '3580601',
  iflix: '3610601',
};

export const ORIPTInfo = {
  wetv: 'WETVLINUX',
  iflix: 'IFLIXLINUX',
};

export const licenceInfo = {
  wetv: 'WETVLINUX',
  iflix: 'IFLIXLINUX',
};

export const defaultLangCode = '1491988';
